<template>
  <div class="table-container">
    <div class="table-body">
      <div class="table-tools mb-10">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-plus"
          @click="openMenuDialog"
          >添加</el-button
        >
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete-solid"
          @click="deleteBatchMenu"
          >批量删除</el-button
        >
      </div>
      <!--default-expand-all-->
      <el-table
        :data="menuList"
        row-key="id"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          type="selection"
          width="40"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="menuName"
          label="菜单名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="path"
          label="链接"
          align="center"
        ></el-table-column>
        <el-table-column label="图标" width="80" align="center">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" size="small">启用</el-tag>
            <el-tag v-else type="danger" size="small">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              class="mr-20"
              @click="() => openUpdateMenu(scope.row)"
            >
              编辑
            </el-button>
            <el-popconfirm
              class="mr-20"
              :title="'确定删除菜单 ' + scope.row.menuName + ' 吗？'"
              @onConfirm="() => deleteMenu(scope.row)"
            >
              <el-button
                slot="reference"
                icon="el-icon-delete"
                type="text"
                size="small"
                class="text-danger"
              >
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!--分页条-->
      <div class="pagination">
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          :total="page.totalSize"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <!--菜单模态框-->
    <div class="dialog">
      <el-dialog
        :title="menu_dialog_title"
        @close="resetForm('menuForm')"
        :visible.sync="menuDialogVisible"
        custom-class="common-dialog"
        :close-on-click-modal="false"
      >
        <div class="fc_dialog_body">
          <el-form :model="menuForm" :rules="menuRules" ref="menuForm">
            <el-form-item label="父菜单：">
              <el-select
                @change="selectChange"
                v-model="menuForm.parentId"
                clearable
                placeholder="选择父菜单"
              >
                <el-option
                  v-for="item in pMenu"
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="菜单名称：" prop="menuName">
              <el-input
                size="medium"
                v-model="menuForm.menuName"
                autocomplete="off"
                placeholder="菜单名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="菜单图标：" prop="icon">
              <i :class="menuForm.icon"></i>
              <el-input
                size="medium"
                v-model="menuForm.icon"
                autocomplete="off"
                placeholder="菜单图标"
              ></el-input>
            </el-form-item>
            <el-form-item label="菜单链接：" prop="path">
              <el-input
                size="medium"
                v-model="menuForm.path"
                autocomplete="off"
                placeholder="菜单链接"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
              <el-input
                style="width: 75px"
                size="medium"
                v-model="menuForm.sort"
                autocomplete="off"
                placeholder="排序"
              ></el-input>
            </el-form-item>
            <el-form-item label="菜单状态：" prop="status">
              <el-tooltip
                :content="menuForm.status === 1 ? '启用' : '禁用'"
                placement="right"
              >
                <el-switch
                  v-model="menuForm.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="menuDialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            :class="{ dn: dn }"
            @click="addMenu('menuForm')"
            >确 定</el-button
          >
          <el-popconfirm
            :class="{ dn: !dn }"
            :title="'确定更新？'"
            @onConfirm="updateMenu('menuForm')"
          >
            <el-button
              slot="reference"
              size="small"
              type="primary"
              class="ml-10"
              >更 新</el-button
            >
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      menuList: [],
      pMenu: [],
      menuForm: {
        id: '',
        parentId: '',
        menuName: '',
        icon: '',
        path: '',
        status: 1,
        sort: '',
      },
      menuRules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
        ],
        icon: [{ required: true, message: '请选择菜单图标', trigger: 'blur' }],
      },
      menuDialogVisible: false,
      menu_dialog_title: '',
      dn: false,
      page: {
        //当前页
        current: 1,
        //当前每页显示条数
        size: 10,
        //可选数据显示条数
        sizes: [10],
        //总数据条数
        totalSize: 0,
        //总页数
        totalPages: 0,
        //实际显示条数
        realSize: 0,
      },
    }
  },
  created() {
    this.getAllMenu()
  },
  methods: {
    //获取所有菜单
    getAllMenu() {
      this.$axios.post({
        url: '/menu/all',
        success: (res) => {
          if (res.code === 0) {
            this.menuList = this.$toTree.toTree(res.data)
            this.page.totalSize = res.data.length
            this.page.totalPages = 1
            this.page.realSize = res.data.length
            this.page.sizes = [res.data.length]
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    //获取父菜单
    getPMenu() {
      this.$axios.post({
        url: '/menu/parent',
        success: (res) => {
          if (res.code === 0) {
            this.pMenu = res.data
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    //打开菜单模态框
    openMenuDialog() {
      this.getPMenu()
      this.menu_dialog_title = '添加菜单'
      this.dn = false
      this.menuDialogVisible = true
    },
    //添加菜单
    addMenu(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post({
            url: '/menu/add',
            data: this.menuForm,
            success: (res) => {
              switch (res.code) {
                case 0: {
                  this.getAllMenu()
                  this.$message.success('菜单添加成功')
                  this.menuDialogVisible = false
                  break
                }
                default: {
                  this.$message.error(res.msg)
                  break
                }
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        } else {
          return false
        }
      })
    },
    //打开菜单修改模态框
    openUpdateMenu(data) {
      this.menu_dialog_title = '更改菜单'
      this.dn = true
      this.menuDialogVisible = true //模态框必须先显示，这样表单才会先出来，下面的方法才有用
      this.$nextTick(() => {
        // 注意,必须有，不然会有问题
        this.getPMenu()
        this.menuForm.id = data.id
        this.menuForm.menuName = data.menuName
        this.menuForm.path = data.path
        this.menuForm.icon = data.icon
        this.menuForm.status = data.status
        this.menuForm.sort = data.sort
        if (data.parentId === 0 || data.parentId === undefined) {
          this.menuForm.parentId = null
        } else {
          this.menuForm.parentId = data.parentId
        }
      })
    },
    //修改菜单
    updateMenu(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.menuForm.id === this.menuForm.parentId) {
            this.$message.error('不能将自身设为父菜单')
            return
          }
          this.$axios.post({
            url: '/menu/update',
            data: this.menuForm,
            success: (res) => {
              switch (res.code) {
                case 0: {
                  this.$message.success('菜单修改成功')
                  this.menuDialogVisible = false
                  this.getAllMenu()
                  break
                }
                case 1: {
                  this.$message.error(res.data)
                  break
                }
                default: {
                  break
                }
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        } else {
          return false
        }
      })
    },
    //删除菜单
    deleteMenu(data) {
      this.$axios.post({
        url: '/menu/delete/' + data.id,
        success: (res) => {
          switch (res.code) {
            case 0: {
              this.getAllMenu()
              this.$message.success('菜单删除成功')
              this.menuDialogVisible = false
              break
            }
            case 1: {
              this.$message.error(res.data)
              break
            }
            default: {
              break
            }
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    //批量删除菜单
    deleteBatchMenu() {
      let ids = this.$refs.menuTree.getCheckedKeys()
      if (ids.length <= 0) {
        this.$message.warning('请选中要删除的数据')
        return
      }
      this.$confirm('此操作将永久删除此数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post({
            url: '/menu/deleteBatch/',
            data: ids,
            success: (res) => {
              switch (res.code) {
                case 0: {
                  this.getAllMenu()
                  this.$message.success('菜单删除成功')
                  this.menuDialogVisible = false
                  break
                }
                case 1: {
                  this.$message.error(res.data)
                  break
                }
                default: {
                  break
                }
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        })
        .catch(() => {
          return false
        })
    },
    //父菜单改变
    selectChange() {},
    //格式化表单
    // eslint-disable-next-line no-unused-vars
    resetForm(formName) {
      this.menuForm.parentId = ''
      this.menuForm.id = ''
      this.$refs[formName].resetFields()
    },
    //改变当前显示条数
    sizeChange(val) {
      this.page.size = val
      this.getAllMenu()
    },
    //改变当前页
    currentChange(val) {
      this.page.current = val
      this.getAllMenu()
    },
  },
}
</script>

<style scoped>
.el-tree {
  /*max-width: 700px;*/
}
.el-tree >>> .el-tree-node__content {
  height: auto;
  min-height: 40px !important;
  font-size: 0.85rem;
  margin-bottom: 7.5px;
}
.el-tree >>> .el-tree-node {
  white-space: normal;
}
.menu_name {
  min-width: 100px;
  display: inline-block;
}
.menu_url {
  min-width: 120px;
  display: inline-block;
}
.pagination {
  margin-top: 1rem;
}
.el-form >>> .el-form-item {
  margin-bottom: 12px;
}
</style>
